var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m120 112a24 24 0 0 0 -24 24v112l56 16 88-40 24-72-16-40z",
    fill: "#7dafff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m192 160h64v16h-64z",
    fill: "#548aff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m128 160h48v16h-48z",
    fill: "#548aff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m128 200h112v16h-112z",
    fill: "#548aff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m408 169.93994v294.06006a24.00619 24.00619 0 0 1 -24 24h-240a24.00619 24.00619 0 0 1 -24-24v-200l128-32v-152h70.06006a24.04835 24.04835 0 0 1 16.97021 7.03l65.93946 65.94a24.0487 24.0487 0 0 1 7.03027 16.96994z",
    fill: "#548aff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#486be0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160 416h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 416h56v16h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 416h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 368h24v16h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200 368h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 320h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 320h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 240h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 240h72v16h-72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 192h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 192h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 368h56v16h-56z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m231.201 232.615h39.598v36.77h-39.598z",
    fill: "#f78e00",
    transform: "matrix(.707 -.707 .707 .707 -103.968 251)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m253.619 258.927h45.255v34.639h-45.255z",
    fill: "#ffb401",
    transform: "matrix(.707 -.707 .707 .707 -114.425 276.247)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m334.059 254.863h67.882v226.274h-67.882z",
    fill: "#ffc431",
    transform: "matrix(.707 -.707 .707 .707 -152.431 368)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m424 472 6.05888 6.05888a33.9411 33.9411 0 0 0 24 9.94112h.00005a33.94109 33.94109 0 0 0 33.94107-33.94109v-.00005a33.9411 33.9411 0 0 0 -9.94112-24l-6.05888-6.05886z",
    fill: "#ffb401"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m152 24a128 128 0 1 0 128 128 128.00009 128.00009 0 0 0 -128-128zm0 224a96 96 0 1 1 96-96 96.00006 96.00006 0 0 1 -96 96z",
    fill: "#ffc431"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m405.83984 160h-61.83984a15.99571 15.99571 0 0 1 -16-16v-61.84009a23.90368 23.90368 0 0 1 7.03027 4.87009l65.93946 65.94a23.8878 23.8878 0 0 1 4.87011 7.03z",
    fill: "#7dafff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.cc423f13ab7d874d8f1568cdf15be215.svg";
export { ForwardRef as ReactComponent };